'use strict';exports.__esModule = true;var _constants = require('../constants');

var getMapUrl = function getMapUrl(_ref, locale, hasPropertyImage) {var lat = _ref.lat,lon = _ref.lon;
  var mapsApiUrl = 'https://maps.googleapis.com/maps/api/staticmap';
  var options = {
    center: lat + ',' + lon,
    zoom: 15,
    scale: 2,
    size: (hasPropertyImage ? 303 : 658) + 'x226',
    format: 'png',
    language: locale,
    key: _constants.googleSdkConfig.apiKey };

  var params = Object.
  keys(options).
  reduce(function (acc, key) {
    acc += key + '=' + options[key] + '&';
    return acc;
  }, '?').
  slice(0, -1);
  return mapsApiUrl + params;
};exports.default =

getMapUrl;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/getMapUrl.js
// module id = 1293
// module chunks = 0